export const equal = (a1 = [], a2 = []) =>
  a1 === a2 ||
  (a1.length === a2.length &&
    a1.every((i) => a2.includes(i)) &&
    a2.every((i) => a1.includes(i)));

export default null;
